import PropTypes from "prop-types"
import React from "react"

class AdvancedOptions extends React.Component {
  constructor(props) {
    super(props)
    this.valueChange = this.valueChange.bind(this)
  }

  valueChange(name, event) {
    const obj = {}
    obj[name] = event.target.value
    this.props.setParentState(obj)
  }

  render() {
    return (
      <div className="row nested-row" style={{ marginTop: 15 }}>
        <div className="col-sm-2">
          <div className="pricing-form-label">Min Nights</div>
          <div className="pricing-form-label">Min Price</div>
        </div>
        <div className="col-sm-4">
          <input
            type="text"
            className="form-control"
            onChange={(e) => this.valueChange("minNights", e)}
            value={this.props.minNights}
          />
          <input
            type="text"
            className="form-control"
            onChange={(e) => this.valueChange("minPrice", e)}
            value={this.props.minPrice}
            style={{ marginTop: 15 }}
          />
        </div>
        <div className="col-sm-2">
          <div className="pricing-form-label">Beam</div>
        </div>
        <div className="col-sm-4">
          <div className="input-group">
            <div className="input-group-addon-mini">min</div>
            <input
              type="text"
              className="form-control"
              onChange={(e) => this.valueChange("minBeam", e)}
              value={this.props.minBeam}
            />
            <span className="input-group-addon">ft</span>
          </div>
          <div className="input-group" style={{ marginTop: 15 }}>
            <div className="input-group-addon-mini">max (up to)</div>
            <input
              type="text"
              className="form-control"
              onChange={(e) => this.valueChange("maxBeam", e)}
              value={this.props.maxBeam}
            />
            <span className="input-group-addon">ft</span>
          </div>
        </div>
      </div>
    )
  }
}

AdvancedOptions.propTypes = {
  minNights: PropTypes.string,
  minPrice: PropTypes.string,
  minBeam: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxBeam: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setParentState: PropTypes.func.isRequired,
}

export default AdvancedOptions
